import assetPath from '/app/packages/startpage-logged-out/native-apps-section/src/assets/background.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')